export const links = [
  {
    name: 'Cellar',
    tracking: 'topnav_control_cellar',
    url: 'http://www.waitrosecellar.com/',
  },
  {
    name: 'Dishpatch',
    tracking: 'topnav_dishpatch',
    url: 'https://dishpatch.co.uk/',
  },
];
